// Copyright (c) 2020-2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

export enum SendanorApiHeader {
    AUTHORIZATION = 'Authorization'
}
